import React, { useEffect, useState } from "react";
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";

const Loader = ({ onFinish = () => {}, logo }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [error, setError] = useState(false); // <-- nuevo estado para error de imagen

  // Si no viene logo, intenta desde localStorage
  if (
    localStorage.getItem("logo") !== null &&
    localStorage.getItem("logo") !== undefined &&
    localStorage.getItem("logo") !== ""
  ) {
    if (logo === undefined || logo === null || logo === "") {
      logo = localStorage.getItem("logo");
    }
  }

  const optimizedLogo = buildCloudinaryImageUrl({ url: logo, width: 300, quality: "auto", type: "image" });

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        onFinish(); // Notifica que terminó
      }, 500); // Duración del fadeOut
    }, 1000); // Duración total visible

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className={`loader-container ${fadeOut ? "fade-out" : ""}`}>
      {/* Si la imagen existe y no dio error → mostrarla */}
      {optimizedLogo && !error ? (
        <img
          src={optimizedLogo}
          alt="Logo"
          className="loader-logo"
          onError={() => setError(true)} // si está rota → mostrar spinner
        />
      ) : (
        // Si hay error, null, undefined o vacía → mostrar spinner
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      )}
    </div>
  );
};

export default Loader;